import { createFileRoute } from '@tanstack/react-router';

export default function Roles() {
  return <div>RolePermissions</div>;
}

export const Route = createFileRoute('/_authenticated/dashboard/accounts/roles')({
  component: Roles,
});
